import React from "react";

import PropTypes from "prop-types";

export default function Card({ children }) {
  return <div className="bg-slate-900 w-full p-6 rounded-xl">{children}</div>;
}

Card.propTypes = {
  children: PropTypes.node,
};
